import { Grid } from "@mui/material";

import { Accardion } from "../../../components";

const FaqBody = ({ faqList }) => {
    return (
        <Grid container spacing={2}>
            {faqList.map((item, index) => (
                <Grid
                    item
                    key={index}
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    xl={6}
                >
                    <Accardion
                        title={item.question}
                        description={item.answer}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default FaqBody;
